import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export const Includes = () => {
  const steps = [{
    num: '01',
    title: 'Evaluación inicial y detección del TCA',
    desc: 'Protocolo de primera consulta para evaluar conducta alimentaria, relación con el cuerpo, conciencia del problema, impacto emocional, social y funcional, señales de riesgo y criterios de interconsulta.'
  }, {
    num: '02',
    title: 'Diagnóstico diferencial y conceptualización del caso',
    desc: 'Sistema para formular el caso clínico integrando conducta alimentaria, regulación emocional, imagen corporal, creencias, contexto familiar y factores de mantenimiento.'
  }, {
    num: '03',
    title: 'Plan de tratamiento interdisciplinario',
    desc: 'Diseño del plan terapéutico por objetivos, etapas, prioridades y coordinación profesional. Adaptado a la complejidad clínica de los TCA y al trabajo con otros profesionales cuando corresponde.'
  }, {
    num: '04',
    title: 'Motivación, ambivalencia y adherencia al tratamiento',
    desc: 'Protocolo para trabajar con pacientes que reconocen parcialmente el problema, temen cambiar o sienten que el TCA todavía les brinda control, seguridad o identidad.'
  }, {
    num: '05',
    title: 'Intervención cognitiva, emocional y conductual',
    desc: 'Sistema para trabajar pensamientos, emociones y comportamientos que mantienen el trastorno: culpa, ansiedad, reglas rígidas, atracones, evitación, chequeo corporal y conductas compensatorias.'
  }, {
    num: '06',
    title: 'Imagen corporal, autoestima e identidad',
    desc: 'Protocolo para trabajar la relación con el cuerpo, la sobrevaloración de la imagen, la autocrítica, la comparación y la reconstrucción de una identidad no centrada únicamente en el peso o la apariencia.'
  }, {
    num: '07',
    title: 'Familia, entorno y situaciones de crisis',
    desc: 'Protocolo para trabajar con familiares, pareja o figuras significativas sin quitarle voz al paciente. Incluye orientación familiar, señales de alarma, límites, confidencialidad y manejo de crisis.'
  }, {
    num: '08',
    title: 'Seguimiento, prevención de recaídas y alta',
    desc: 'Sistema para monitorear avances, identificar señales tempranas de recaída, consolidar recursos, preparar el cierre terapéutico y dejar un plan de seguimiento post alta.'
  }];
  return <section className="py-20 px-4 bg-white text-brand-teal-dark" data-id="element-71">
      <div className="max-w-4xl mx-auto" data-id="element-72">
        <div className="text-center mb-16" data-id="element-73">
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6" data-id="element-74">
            QUÉ INCLUYE KIT PSICOLOGÍA EN TCA
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-75">
            Todo lo que necesitás para estructurar el abordaje clínico de
            pacientes con trastornos de la conducta alimentaria desde la primera
            consulta hasta el cierre del proceso.
          </p>
          <div className="mt-6 font-semibold text-brand-teal border-b-2 border-brand-gold inline-block pb-1" data-id="element-76">
            Guía Principal: KIT Psicología en TCA — Sistema Psicología en TCA™
            en 8 etapas
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-5" data-id="element-77">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="relative bg-brand-cream p-4 md:p-6 rounded-xl border-t-4 border-brand-gold shadow-sm flex flex-col" data-id="element-78">
              <span className="block text-2xl md:text-3xl font-serif font-bold text-brand-teal/25 mb-1.5 leading-none" data-id="element-79">
                {step.num}
              </span>
              <h3 className="text-sm md:text-lg font-bold font-serif text-brand-teal leading-snug" data-id="element-80">
                {step.title}
              </h3>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-81">
          <Button className="text-lg py-4 px-10 w-full md:w-auto" data-id="element-82">
            SÍ, QUIERO EL KIT AHORA
          </Button>
        </div>
      </div>
    </section>;
};